import React from 'react';
import { Icon } from 'elements';

const Document = ({size, className}) => (
  <Icon size={size} className={className}>
    <g>
      <path d="M1.524,12.227c1.278,0,2.501-0.458,3.491-1.284c0.992,0.827,2.215,1.284,3.492,1.284
        s2.5-0.458,3.492-1.284c0.991,0.827,2.214,1.284,3.491,1.284c1.277,0,2.5-0.458,3.492-1.284c0.991,0.827,2.214,1.284,3.492,1.284
        c0.635,0,1.149-0.554,1.149-1.237s-0.515-1.237-1.149-1.237c-1.009,0-1.961-0.478-2.612-1.313C19.645,8.162,19.323,8,18.984,8
        c0,0,0,0,0,0c-0.339,0-0.662,0.162-0.88,0.441c-0.652,0.834-1.604,1.313-2.612,1.313c-1.008,0-1.96-0.478-2.611-1.312
        C12.662,8.162,12.341,8,12.001,8h0c-0.339,0-0.661,0.161-0.88,0.441c-0.652,0.834-1.605,1.313-2.613,1.313
        c-1.008,0-1.96-0.479-2.613-1.313C5.676,8.161,5.355,8,5.015,8C4.663,7.995,4.353,8.162,4.135,8.442
        c-0.65,0.834-1.601,1.312-2.61,1.312c-0.635,0-1.149,0.554-1.149,1.237S0.89,12.227,1.524,12.227z"/>
      <path d="M22.476,16.095c-1.009,0-1.961-0.478-2.612-1.312c-0.218-0.28-0.541-0.441-0.88-0.441
        c0,0,0,0,0,0c-0.339,0-0.662,0.162-0.88,0.441c-0.652,0.834-1.604,1.313-2.612,1.313c-1.009,0-1.96-0.478-2.611-1.312
        c-0.218-0.28-0.54-0.441-0.88-0.441h0c-0.339,0-0.661,0.161-0.88,0.441c-0.652,0.834-1.605,1.313-2.613,1.313
        c-1.008,0-1.96-0.479-2.613-1.313c-0.218-0.279-0.54-0.44-0.879-0.44c0,0-0.001,0-0.001,0c-0.339,0-0.662,0.162-0.88,0.442
        c-0.65,0.834-1.601,1.311-2.61,1.311c-0.635,0-1.149,0.554-1.149,1.237c0,0.683,0.515,1.237,1.149,1.237
        c1.278,0,2.501-0.458,3.491-1.284c0.992,0.826,2.215,1.284,3.492,1.284c1.277,0,2.5-0.458,3.492-1.284
        c0.991,0.826,2.214,1.284,3.491,1.284c1.277,0,2.5-0.458,3.492-1.284c0.991,0.826,2.214,1.284,3.492,1.284
        c0.635,0,1.149-0.554,1.149-1.237C23.625,16.649,23.11,16.095,22.476,16.095z"/>
    </g>
  </Icon>
);

export default Document;



// WEBPACK FOOTER //
// ./src/core/icons/components/Waves.jsx